export default __webpack_public_path__ + "static/media/new-placeholder-template.ba1833cb.svg";